export default __webpack_public_path__ + "static/media/Craggy_Kitchen3.9d477cad.jpg";